import React from 'react';
import { Icon } from '@types';

export const Document = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<path
				fill="#008635"
				d="M5.5 6A3.49 3.49 0 019 2.5h8.531c.657 0 1.367.328 1.86.82l6.289 6.29c.492.492.82 1.203.82 1.859V27a3.49 3.49 0 01-3.5 3.5H9c-1.969 0-3.5-1.531-3.5-3.5V6zm19.25 7h-6.125A2.591 2.591 0 0116 10.375V4.25H9c-.984 0-1.75.82-1.75 1.75v21c0 .984.766 1.75 1.75 1.75h14c.93 0 1.75-.766 1.75-1.75V13zm-.273-2.133l-6.344-6.344c-.11-.109-.274-.164-.383-.218v6.07c0 .492.383.875.875.875h6.07c-.054-.11-.11-.273-.218-.383z"
			></path>
		</svg>
	);
};
